import React, { useState, useEffect, useRef } from "react";
import { Checkbox, BlockStack, Banner,Card,Icon, OptionList, Scrollable, Popover, Button, Tag, InlineStack, Box, Text } from "@shopify/polaris";
import ShopifyModal from "../../../../../components/ShopifyModal";
import {PlusIcon,DeleteIcon,SelectIcon} from "@shopify/polaris-icons";
import "./index.css";
import {
  reqPostUpdateOrderPaymentConfig,
  reqGetOrderPaymentConfig,
} from "../../../../../api";
import intl from "../../../../../i18n/intl";
import CountrySelectList from "../../../ProductSelection/component/CountrySelectList";
import { store } from "../../../../../store";
import { changeBannerData } from "../../../../../slice";
const AutoFulfillmentModal = ({ open, setSwitchChecked,setAutoData,toastFun }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [saveLoading, setSaveLoading] = useState(false);
  const [pageData,setPageData] = useState({})
  const [showId, setShowId] = useState("");
  const containerRef = useRef(null);
  const [countryLoading, setCountryLoading] = useState(false);
  const [bannerData, setBannerData] = useState({
    first: false,
    second: false,
  }); // banner提示展示
  let person = store.getState().languageReducer.subScriptData;
  const initData = async () => {
    setIsLoading(true);
    setBannerData((prevValue)=>({
      ...prevValue,
      first:false,
      second:false
    }))
    try {
      const res = await reqGetOrderPaymentConfig();
     if (res.code === '200') {
      setPageData(res.data)
     }
     setTimeout(() => {
      setIsLoading(false);
    }, 800);
    } catch (error) {}
  };
  useEffect(() => {
    if (open) {
      initData();
    }
  }, [open]);
// 保存数据
  const saveData = async () => {
      try {
        let userShippingData = pageData?.userShipping.filter((item,ind)=>item.child.length !== 0)
        setSaveLoading(true);
      const res = await reqPostUpdateOrderPaymentConfig({
        auto_pay: pageData?.auto_pay,
        auto_complete: pageData?.auto_complete,
        userShippingData: JSON.stringify(userShippingData)
      })
      if (res.code === '200' || res.code === 200) {
        // success
        toastFun('Saved successfully')
        setAutoData((prevValue)=>({
          ...prevValue,
          autoFulfillment:true
        }))
        setTimeout(() => {
          setSaveLoading(false);
          setSwitchChecked();
        }, 1000);
      }else{
        setAutoData((prevValue)=>({
          ...prevValue,
          autoFulfillment:false
        }))
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:res.msg
        }}));
      }
      } catch (error) {
      }
    }
  
  // 物流方式选择
  const handleCountrySelect = (value, label) => {
    if (person.level === 0 || person.level === 4) {
      return;
    }
    if (countryLoading) {
      setShowId("");
      return;
    }
    setCountryLoading(true);
    try {
      setPageData((prev) => ({
        ...prev,
        userShipping: prev.userShipping.map(
          (item, ind) => {
            if (ind === showId) {
              return {
                ...item,
                country_code: value,
                country_name: label,
              };
            } else {
              return item;
            }
          }
        ),
      }));

      setTimeout(() => {
        setShowId("");
        setCountryLoading(false);
      }, 1500);
    } catch (error) {
      setCountryLoading(false);
    }
  };

  // 添加物流选项
  const handleShippingMethods = () => {
    if (person.level === 0 || person.level === 4) {
      return;
    }
    setPageData((prev) => ({
      ...prev,
      userShipping: [
        ...prev.userShipping,
        {
          id: 0,
          country_code: "",
          country_name: "",
          child: [],
        },
      ],
    }));
  };
  // 删除物流方式
  const handleShippingMethodsRemove = (id) => {
    setPageData((prev) => ({
      ...prev,
      userShipping: prev.userShipping.filter(
        (item, ind) => ind !== id
      ),
    }));
  };
  const [showChildId, setShowChildId] = useState("");
  // 单个子项物流选项添加
  const handleChildShippingMethods = (value, list) => {
    if (person.level === 0 || person.level === 4) {
      return;
    }
    setPageData((prev) => ({
      ...prev,
      userShipping: prev.userShipping.map(
        (item, ind) => {
          if (ind === showChildId) {
            let flag = true; // 判断是否重复选择
            let childData = item.child;
            childData.forEach((it, ins) => {
              if (it.shipping_methods === value[0]) {
                flag = false;
              }
            });
            if (!flag) {
              childData = item.child.filter(
                (it, k) => it.shipping_methods !== value[0]
              );
            } else {
              childData.push({
                shipping_methods: value[0],
                shipping_name: value[0],
              });
            }
            return {
              ...item,
              child: childData,
            };
          } else {
            return item;
          }
        }
      ),
    }));
    setBannerData((prevValue) => ({
      ...prevValue,
      first: false,
      second: false,
    }));
  };

  // 单个子项物流选项移除
  const handleChildShippingMethodsRemove = (childId, key) => {
    setShowChildId("");
    setPageData((prev) => ({
      ...prev,
      userShipping: prev.userShipping.map(
        (item, ind) => {
          if (item.id === childId) {
            return {
              ...item,
              child: item.child.filter((it, k) => k !== key),
            };
          } else {
            return item;
          }
        }
      ),
    }));
  };

  return (
    <ShopifyModal
      id="auto-fulfillment-modal"
      // loading={isLoading}
      open={open}
      onClose={()=>{
        setSwitchChecked()
        setBannerData((prevValue)=>({
          ...prevValue,
          first:false,
          second:false
        }))
      }}
      heading={intl.get("Auto Fulfillment")}
      primaryAction={{
        content: intl.get("Done"),
        onAction: ()=>saveData(),
        loading: saveLoading,
        disabled: isLoading,
      }}
      secondaryActions={[
        {
          content: intl.get("Cancel"),
          onAction: ()=>{
            setSwitchChecked()
          },
        },
      ]}
    >
      <div style={{minHeight:'300px',maxHeight:'550px',overflowX:'hidden',overflowY:'auto'}}>
      
       <BlockStack gap={300}>
                {/* <Box>
                  <Box>
                    <Text variant="headingSm" as="h6">
                      Auto payment settings
                    </Text>
                  </Box>
                  <Text as="p" tone="subdued">
                    Settings for products, e.g. import AliExpress products, import
                    TEMU products
                  </Text>
                </Box> */}
                {bannerData.first && (
                  <Banner
                    title="Default payment method"
                    tone="warning"
                    onDismiss={() => {
                      setBannerData((prevValue) => ({
                        ...prevValue,
                        first: false,
                        second: false,
                      }));
                    }}
                  >
                    <p>
                      {"Please set the credits as the default payment method first"}
                    </p>
                  </Banner>
                )}
                {bannerData.second && (
                  <Banner
                    title="Default shipping method"
                    tone="warning"
                    onDismiss={() => {
                      setBannerData((prevValue) => ({
                        ...prevValue,
                        first: false,
                        second: false,
                      }));
                    }}
                  >
                    <p>{"Please set the default shipping method first"}</p>
                  </Banner>
                )}
                <Box>
                  <InlineStack blockAlign="center" wrap={false}>
                    <Checkbox
                      checked={pageData?.auto_complete}
                      onChange={(val) => {
                        if (person.level === 0 || person.level === 4) {
                          return;
                        }
                        setPageData((prev) => ({
                          ...prev,
                          auto_complete: val ? 1 : 0,
                        }));
                        if (val) {
                          setBannerData((prevValue) => ({
                            ...prevValue,
                            first: false,
                            second: false,
                          }));
                          let flag = true;
                          pageData?.userShipping.forEach((item, ind) => {
                            if (item.child.length === 0) {
                              flag = false;
                            }
                          });
                          if (!flag) {
                            setBannerData((prevValue) => ({
                              ...prevValue,
                              first: false,
                              second: true,
                            }));
                          }
                        } else {
                          setBannerData((prevValue) => ({
                            ...prevValue,
                            first: true,
                            second: false,
                          }));
                        }
                      }}
                    />
                    <p>
                      Set Dropshipman Credits payment as the default payment method
                    </p>
                  </InlineStack>
                  <Box style={{ marginLeft: "26px" }}>
                    <Text as="span" tone="subdued">
                      When there is an order fulfilled by Dropshipman, the default
                      payment method is credits payment.
                    </Text>
                  </Box>
                </Box>
                <Box>
                  <InlineStack blockAlign="center" wrap={false}>
                    <Checkbox
                      checked={pageData?.auto_pay}
                      onChange={(val) => {
                        if (person.level === 0 || person.level === 4) {
                          return;
                        }
                        setPageData((prev) => ({
                          ...prev,
                          auto_pay: val ? 1 : 0,
                        }));
                      }}
                    />
                    <p>Set up automatic payments for Dropshipman orders.</p>
                  </InlineStack>
                  <Box style={{ marginLeft: "26px" }}>
                    <Text as="span" tone="subdued">
                      When there is an order fulfilled by Dropshipman, and the default
                      logistics method has been set for the order, and the balance in
                      the credits is sufficient to pay the order, the system
                      automatically completes the payment of the order without manual
                      payment.
                    </Text>
                  </Box>
                </Box>
                <Card>
                  <Box>
                    <BlockStack gap={200}>
                      <Box>
                        <Text variant="headingSm" as="h6">
                          Default logistics settings
                        </Text>
                      </Box>
                      <Text as="p" tone="subdued">
                        Settings for products, e.g. import AliExpress products, import
                        TEMU products
                      </Text>
                      {pageData?.userShipping &&
                        pageData?.userShipping.map((item, ind) => (
                          <Card padding={0} key={ind}>
                            <Box
                              style={{
                                background: "rgba(247, 247, 247, 1)",
                                padding: "16px",
                              }}
                            >
                              <InlineStack
                                gap={200}
                                align="space-between"
                                blockAlign="center"
                              >
                                <Box style={{ width: "70%" }}>
                                  <BlockStack gap={100}>
                                    <Box>
                                      <Box className="btn_currency">
                                        <Popover
                                          active={showId === ind}
                                          activator={
                                            <Button
                                              loading={countryLoading}
                                              onClick={(e) => {
                                                if (
                                                  person.level === 0 ||
                                                  person.level === 4
                                                ) {
                                                  return;
                                                }
                                                if (showId === ind) {
                                                  setShowId("");
                                                } else {
                                                  setShowId(ind);
                                                }
                                              }}
                                            >
                                              <InlineStack align="space-between">
                                                {item?.country_code !== "" ? (
                                                  <p style={{ marginRight: "10px" }}>
                                                    <img
                                                      src={`https://flagcdn.com/w20/${item?.country_code.toLowerCase()}.png`}
                                                      alt="loading..."
                                                    />
                                                    <span
                                                      style={{ marginLeft: "5px" }}
                                                    >
                                                      {item?.country_name}
                                                    </span>
                                                  </p>
                                                ) : (
                                                  "Country/Region"
                                                )}
                                                <span>
                                                  <Icon source={SelectIcon}></Icon>
                                                </span>
                                              </InlineStack>
                                            </Button>
                                          }
                                          autofocusTarget="first-node"
                                          onClose={() => {
                                            setShowId("");
                                          }}
                                        >
                                          <CountrySelectList
                                            containerRef={containerRef}
                                            setShowId={setShowId}
                                            handleCountrySelect={handleCountrySelect}
                                            setCountry={""}
                                            country={item?.country_code}
                                          />
                                        </Popover>
                                      </Box>
                                    </Box>
                                    <Box>
                                      <InlineStack
                                        gap={100}
                                        blockAlign="center"
                                        align="start"
                                      >
                                        {item?.child &&
                                          item?.child.map((it, k) => (
                                            <Tag
                                              key={k}
                                              onRemove={() => {
                                                if (
                                                  person.level === 0 ||
                                                  person.level === 4
                                                ) {
                                                  return;
                                                }
                                                handleChildShippingMethodsRemove(
                                                  item.id,
                                                  k
                                                );
                                              }}
                                            >
                                              {it.shipping_methods}
                                            </Tag>
                                          ))}
                                        {item?.child.length < 5 ? (
                                          <Popover
                                            active={showChildId === ind}
                                            activator={
                                              <Button
                                                icon={PlusIcon}
                                                variant="tertiary"
                                                onClick={() => {
                                                  if (
                                                    person.level === 0 ||
                                                    person.level === 4
                                                  ) {
                                                    return;
                                                  }
                                                  if (showChildId === ind) {
                                                    setShowChildId("");
                                                  } else {
                                                    setShowChildId(ind);
                                                  }
                                                }}
                                              >
                                                Add Shipping methods
                                              </Button>
                                            }
                                            onClose={() => {
                                              setShowChildId("");
                                            }}
                                          >
                                            <Scrollable
                                              style={{
                                                height: "300px",
                                                background: "#fff",
                                              }}
                                            >
                                              <OptionList
                                                onChange={(value) =>
                                                  handleChildShippingMethods(
                                                    value,
                                                    item?.child
                                                      .filter(
                                                        (item) =>
                                                          item.shipping_methods !== ""
                                                      )
                                                      .map(
                                                        (item) =>
                                                          item.shipping_methods
                                                      )
                                                  )
                                                }
                                                options={
                                                  pageData?.shippingData
                                                }
                                                selected={item?.child
                                                  .filter(
                                                    (item) =>
                                                      item.shipping_methods !== ""
                                                  )
                                                  .map(
                                                    (item) => item.shipping_methods
                                                  )}
                                              />
                                            </Scrollable>
                                          </Popover>
                                        ) : (
                                          <span
                                            style={{ color: "rgba(181,181,181,1)" }}
                                          >
                                            Up to 5
                                          </span>
                                        )}
                                      </InlineStack>
                                    </Box>
                                  </BlockStack>
                                </Box>
                                <Box>
                                  <Button
                                    icon={DeleteIcon}
                                    variant="tertiary"
                                    onClick={() => {
                                      if (person.level === 0 || person.level === 4) {
                                        return;
                                      }
                                      handleShippingMethodsRemove(ind);
                                    }}
                                  ></Button>
                                </Box>
                              </InlineStack>
                            </Box>
                          </Card>
                        ))}
                      <Box>
                        <Button
                          icon={PlusIcon}
                          variant="plain"
                          onClick={() => {
                            if (person.level === 0 || person.level === 4) {
                              return;
                            }
                            handleShippingMethods();
                          }}
                        >
                          Add Country/Region{" "}
                        </Button>
                      </Box>
                    </BlockStack>
                  </Box>
                </Card>
              </BlockStack>
      
      </div>
    </ShopifyModal>
  );
};

export default AutoFulfillmentModal;
